var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000155831079766206853280000008863658019269822084_);}\r\n\t.st1{fill:#12BF45;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 68,
    height: 68
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000092447912288037992260000006848836754102893466_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000092447912288037992260000006848836754102893466_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.4,68H13.6C6.1,68,0,61.9,0,54.4V13.6C0,6.1,6.1,0,13.6,0h40.8C61.9,0,68,6.1,68,13.6v40.8 C68,61.9,61.9,68,54.4,68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,40.3c0.3-0.3,0.4-0.8,0.4-1.4v-2l-2.8,0.6c-0.6,0.1-1,0.3-1.2,0.6c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.5,0.2,0.9,0.4,1.1c0.3,0.3,0.8,0.4,1.4,0.4h0.9C14.3,40.8,14.7,40.6,15,40.3 M8,43c-0.8-0.8-1.2-1.9-1.2-3.3 c0-0.9,0.1-1.6,0.4-2.2S8,36.4,8.7,36c0.7-0.4,1.7-0.8,2.9-1l2.1-0.4c0.5-0.1,0.8-0.2,1-0.3c0.2-0.1,0.4-0.3,0.5-0.4 c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.5-0.3C14.4,32,14,32,13.6,32H7.6v-3c0.6-0.2,1.4-0.3,2.5-0.4 c1-0.1,2-0.2,3-0.2c1.6,0,2.9,0.2,3.9,0.6c1,0.4,1.6,0.9,2,1.7c0.4,0.8,0.6,1.7,0.6,2.9v10.3h-3.4l-0.8-2.2 c-0.3,0.8-0.8,1.5-1.5,1.9c-0.6,0.4-1.5,0.6-2.5,0.6C9.9,44.2,8.8,43.8,8,43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.7,42.3c-1.2-1.2-1.8-3.2-1.8-6c0-2.8,0.6-4.8,1.8-6c1.2-1.2,2.9-1.8,5.2-1.8c1.4,0,2.7,0.2,4,0.5v3h-3.1 c-1.1,0-1.8,0.2-2.3,0.4c-0.5,0.3-0.8,0.7-1,1.3c-0.1,0.6-0.2,1.4-0.2,2.6c0,1.1,0.1,2.1,0.2,2.6c0.1,0.6,0.5,1,1,1.4 c0.5,0.3,1.3,0.5,2.3,0.5h3.1v2.8c-1.3,0.4-2.6,0.6-4,0.6C26.6,44.2,24.8,43.6,23.7,42.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.2,32.2C43,32.1,42.6,32,41.9,32h-3v-1.5c1.1-1.4,2.6-2,4.3-2c1.5,0,2.6,0.4,3.4,1.1 c0.8,0.8,1.1,1.8,1.1,3.2v11.1h-4.2V33.3C43.6,32.8,43.5,32.4,43.2,32.2 M35,24.6l4.2-0.7v20H35V24.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.3,44c-0.8-0.1-1.5-0.3-2.2-0.5v-2.8h6.5c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.6 c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.4-0.4c-0.2-0.2-0.4-0.3-0.7-0.5l-3.1-1.8c-0.9-0.5-1.6-1.1-2-1.8 c-0.4-0.7-0.6-1.5-0.6-2.5c0-1.3,0.5-2.3,1.5-3.1c1-0.7,2.3-1.1,4-1.1c1.7,0,3.2,0.3,4.7,0.8V32h-5.7c-0.2,0-0.4,0-0.5,0.1 c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.2,0.2,0.4,0.3l4.1,2.2c0.9,0.5,1.6,1,2,1.6c0.4,0.6,0.6,1.4,0.6,2.4 c0,1.6-0.5,2.8-1.5,3.5c-1,0.7-2.5,1.1-4.6,1.1C54,44.2,53.1,44.1,52.3,44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchs);
export default __webpack_public_path__ + "static/media/achs.d54a9fb78d1588db890d7df28fb8b018.svg";
export { ForwardRef as ReactComponent };